import { toast } from '@components';

export function handleTimeoutApiError(
  error: any,
  fallbackMessage = 'An error occurred while loading data.',
) {
  if (
    error?.code === 'ECONNABORTED' ||
    error?.message?.toLowerCase().includes('timeout') ||
    error?.response?.status === 408
  ) {
    toast.error('Your request timed out.');
  } else {
    toast.error(fallbackMessage);
  }
}
